import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { TextButton } from '@xingternal/button';
import { IconArrowDown, IconArrowUp } from '@xingternal/icons';
import { usePopOver } from '@xingternal/pop-over';
import { Slider } from '@xingternal/slider';

import { SliderMarkLabel } from '@/components/slider-mark-label';
import { MAX_SALARY, MIN_SALARY, STEP_SALARY } from '@/domain/search/constants';

import { useSearchQuery } from '../../../contexts';

import * as Common from '../filter-list.common.styles';
import * as S from './filter-salary.styles';

const cleanSalaryParam = (salary?: (number | null)[] | null): number[] => {
  if (!salary) return [MIN_SALARY, MAX_SALARY];

  const filteredSalary = salary.filter((item) => item !== null) as number[];
  return filteredSalary.length === 2 ? filteredSalary : [MIN_SALARY, MAX_SALARY];
};

export const FilterSalary: React.FC = () => {
  const {
    queryParams: [{ salary }, setQueryParams],
  } = useSearchQuery();
  const [sliderValues, setSliderValues] = useState(cleanSalaryParam(salary));
  const popOver = usePopOver();

  useEffect(() => {
    setSliderValues(cleanSalaryParam(salary));
  }, [salary]);

  const handleOnSliderChange = (e: Event, values: number[]): void => {
    setSliderValues(values);
  };

  const handleSetSalary = (e: Event, values: number[]): void => {
    setQueryParams({ salary: values });
  };

  return (
    <Common.FilterContainer>
      <TextButton
        iconAfter
        icon={popOver.show ? IconArrowUp : IconArrowDown}
        innerRef={popOver.triggerRef}
        onClick={popOver.togglePopOver}
      >
        <FormattedMessage id="SE_FILTER_JOBS_SALARY_LABEL" />
      </TextButton>
      <S.Menu
        isInFlow
        onOutsideClick={popOver.handleHide}
        triggerRef={popOver.triggerRef}
        show={popOver.show}
        showCloseButton={false}
      >
        <S.SliderContainer>
          <Slider
            min={MIN_SALARY}
            max={MAX_SALARY}
            step={STEP_SALARY}
            value={sliderValues}
            onChange={handleOnSliderChange}
            onChangeCommitted={handleSetSalary}
          />
        </S.SliderContainer>
        <SliderMarkLabel value={sliderValues[0]} />
        <SliderMarkLabel value={sliderValues[1]} />
      </S.Menu>
    </Common.FilterContainer>
  );
};
